import { Fragment, type ComponentPropsWithoutRef, type ElementType } from "react";

import { cx } from "../../lib/cx";
import { Icon } from "../core/Icon";
import s from "./Breadcrumb.module.css";

export interface BreadcrumbItem {
  label: string;
  /** Sin `href` es el nivel actual (el último) o un ancestro sin página propia. */
  href?: string;
}

export interface BreadcrumbProps extends ComponentPropsWithoutRef<"nav"> {
  items: BreadcrumbItem[];
  /** El componente del enlace, p. ej. `Link` de Next. */
  linkAs?: ElementType;
}

/** Inicio › Propiedades › Serenity Meadows. El último ítem es la página actual y no es enlace. */
export function Breadcrumb({ items, linkAs, className, ...rest }: BreadcrumbProps) {
  const LinkTag: ElementType = linkAs ?? "a";
  return (
    <nav aria-label="Migas" className={cx(s.migas, className)} {...rest}>
      {items.map((it, i) => {
        const ultimo = i === items.length - 1;
        return (
          <Fragment key={`${it.label}-${i}`}>
            {i ? (
              <span className={s.separador} aria-hidden="true">
                <Icon name="chevron-right" size={12} />
              </span>
            ) : null}
            {ultimo || !it.href ? (
              <span className={ultimo ? s.actual : undefined} aria-current={ultimo ? "page" : undefined}>
                {it.label}
              </span>
            ) : (
              <LinkTag href={it.href} className={s.enlace}>
                {it.label}
              </LinkTag>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
